import { API } from "../auth/authApi";

export const getDashboardAnalyticsApi = (params = {}) => {
  return API.get("/dashboard/analytic", { params });
};